const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(row => ({
    ...row,
    ledgerId: row.ledgerId || row.ledgerId === 0 ? `${row.ledgerId}` : null,
    ledgerIdIn: row.ledgerIdIn || row.ledgerIdIn === 0 ? `${row.ledgerIdIn}` : null,
    ledgerIdOut: row.ledgerIdOut || row.ledgerIdOut === 0 ? `${row.ledgerIdOut}` : null,
    connName: row.connName || null,
    businessDescription: row.businessDescription || null,
  }));

export default fixDataTypes;
